import { Component, HostBinding, Inject, Optional } from '@angular/core';
import { MuiComponent } from '../utility/mui-component-base/mui-component';
import { MuiCard } from './mui-card.component';
import { MUI_CARD } from './mui-card.provider';


@Component({
  selector: 'mui-card-header',
  styles: [
    `
      :host {
        display: block;
      }
    `
  ],
  template: `
    <ng-content></ng-content>
  `
})
export class MuiCardHeader extends MuiComponent {
  get id(): string | null {
    if (this._id) {
      return this._id;
    }

    return this._card?.id ? this._card?.id + '-label' : null;
  }

  @HostBinding('class') private readonly _class = 'mui-card__title';
  @HostBinding('attr.role') private readonly _role = 'heading';

  constructor(@Inject(MUI_CARD) @Optional() private _card?: MuiCard) {
    super();
  }
}
